export const conecctDrugManufacturer = (router,clientId) => {
  return router.push(`/${clientId}/settings/POS`)
}

export const connectDrugManufacturer = (router, clientId, posId) =>{
  return router.push(`/${clientId}/settings/POS/${posId}/posDetails`)
}